class RecipeDetailStage {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-recipedetailstage'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$stage = $element;
        this.$stageImage = this.$stage.querySelector(`[${this.settings.initAttr}="image"]`);

        this.initialize();
        this.hoverCounter = 0;
    }

    initialize () {
        if (this.$stageImage) {
            this.addBites();
        }
    }

    addBites () {
        let hoverCounter = 0;
        const $stageImage = this.$stageImage;

        function addAnimation () {
            hoverCounter += 1;
            if (hoverCounter === 1) {
                $stageImage.classList.add('has--rotation');

                setTimeout(() => {
                    $stageImage.classList.add('has--one-bite');
                }, 800);
            }

            if (hoverCounter === 2) {
                $stageImage.classList.add('has--two-bites');
                $stageImage.removeEventListener('mouseenter', addAnimation);
            }
        }

        $stageImage.addEventListener('mouseenter', addAnimation);
    }
}

export { RecipeDetailStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $stage = $context.querySelector('[data-recipedetailstage="root"]');
        if ($stage) {
            const stageAPI = new RecipeDetailStage($stage);
            $stage.API = stageAPI;
        }
    }
});
